<template>
  <div class="logos">
    <img :src="assets.bank.dbsBank" />
    <img :src="assets.bank.posbBank" />
    <img :src="assets.bank.uobBank" />
    <img :src="assets.bank.ocbcBank" />
    <img :src="assets.bank.citiBank" />
    <img :src="assets.bank.standardBank" />
    <img :src="assets.bank.hsbcBank" />
    <img :src="assets.bank.chinaBank" />
    <img :src="assets.bank.icbcBank" />
    <img :src="assets.bank.maybank" />
  </div>
</template>

<script>
import assets from "../../assets/assets";

export default {
  data() {
    return {
      assets
    }
  }
}
</script>

<style lang="scss" scoped>
.logos {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  max-width: 140px;
  gap: 5px;
  margin-inline: auto;

  img {
    border-radius: 15%;
    height: auto !important;
    width: auto !important;
  }
}
</style>